import React from 'react';
import { Button, Card, Typography } from '@guildeducationinc/recess';
import CheckIcon from '@guildeducationinc/recess/icons/CheckIcon';

interface SuccessCardProps {
  email: string;
  handleReset: () => void;
}

const SuccessCard: React.FC<SuccessCardProps> = ({ email, handleReset }) => {
  return (
    <>
      <Card.Content className='flex flexItems--center'>
        <CheckIcon size={50} className='margin--right_16' />
        <Typography
          variant='body1'
          className='referralSuccessMessage'
          data-testid='referralSuccessMessage'
        >
          Your referral was sent successfully to <span className='fontWeight--700'>{email}!</span>
        </Typography>
      </Card.Content>
      <Button className='margin--top_16' appearance='outline' onClick={handleReset}>
        Send another referral
      </Button>
    </>
  );
};

export default SuccessCard;
